import {
    fetchFingerprintSignupReport,
    Filters,
} from 'features/reports/fingerprintSignupReportSlice'
import { useAppDispatch, useAppSelector } from 'hooks/hooks'
import { useCurrentCountry } from 'hooks/miscHooks'
import queryString from 'query-string'
import { useCallback } from 'react'
import { useLocation } from 'react-router-dom'
import ReportFilter, { FilterField, FilterRecord, FilterValue } from './common/ReportFilter'
import { updateUrlWithFilters } from './common/utils'

const convertFiltersToFilterRecord = (filters: Filters): Record<string, FilterValue> => {
    return {
        start_date: filters.start_date,
        end_date: filters.end_date,
    }
}

const FingerprintSignupReportFilter = () => {
    const dispatch = useAppDispatch()
    const location = useLocation()
    const country = useCurrentCountry()

    const { filters, pagination, isLoading } = useAppSelector(
        (state) => state.fingerprintSignupReport,
    )

    const handleUrlUpdate = useCallback(
        (field: string, value: FilterValue) => {
            const currentQuery = queryString.parse(window.location.search, {
                arrayFormat: 'bracket',
            })
            updateUrlWithFilters(location, field, value, currentQuery)
        },
        [location],
    )

    const handlePageChange = useCallback(
        (page: number) => {
            dispatch(fetchFingerprintSignupReport({ filters, page, country }))
        },
        [dispatch, filters, country],
    )

    const handleFetchData = useCallback(
        (newFilters: FilterRecord, page: number = 0) => {
            dispatch(fetchFingerprintSignupReport({ filters: newFilters, page, country }))
        },
        [dispatch, country],
    )

    const fields: FilterField[] = [
        {
            key: 'start_date',
            type: 'date',
            width: 'min-w-[210px]',
        },
        {
            key: 'end_date',
            type: 'date',
            width: 'min-w-[210px]',
        },
    ]

    return (
        <ReportFilter
            fields={fields}
            initialFilters={convertFiltersToFilterRecord(filters)}
            pagination={pagination}
            onPageChange={handlePageChange}
            fetchData={handleFetchData}
            isLoading={isLoading}
            onUrlUpdate={handleUrlUpdate}
        />
    )
}

export default FingerprintSignupReportFilter
